import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import EmojiEmotions from "@material-ui/icons/EmojiEmotions";

import clsx from "clsx";
import { format, isSameDay, parseISO } from "date-fns";

import Box from "@material-ui/core/Box";
import ErrorIcon from "@material-ui/icons/Error";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import WifiTetheringSharpIcon from "@material-ui/icons/WifiTetheringSharp";
import ConfigureDays from "../../helpers/ConfigureDays";
import NearMeIcon from "@material-ui/icons/NearMe";

import {
  Avatar,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Popover,
  Button,
  CircularProgress,
  IconButton,
  ListItemAvatar,
  makeStyles,
  Divider,
  TextField,
  InputAdornment,
} from "@material-ui/core";

import EmojiPicker from "emoji-picker-react";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { Block, Done, DoneAll, ExpandMore, GetApp } from "@material-ui/icons";

import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import MessageIcon from "@material-ui/icons/Message";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import socket from "../../hooks/useSocket";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import MarkdownWrapper from "../MarkdownWrapper";
import MessageOptionsMenu from "../MessageOptionsMenu";
import ModalImageCors from "../ModalImageCors";
import SkeletonMessages from "./skeleton";
import {
  findDescriptionInAd,
  findImageInAd,
  findTitleInAd,
  findUrlInAd,
} from "../../helpers/FilterAdMessage";
import EmojiGroup from "../EmojiGroup";
import JsonParse from "../../helpers/JsonParse";
import classNames from "classnames";
import EditIcon from "@material-ui/icons/Edit";
import AlarmOutlinedIcon from "@material-ui/icons/AlarmOutlined";
import GetUrlTicketPath from "../../helpers/GetUrlTicketPath";
import ApiIcon from "@mui/icons-material/Api";

import {
  addItem,
  deleteItem,
  getAllItems,
  getItemById,
  updateItem,
} from "../../helpers/IndexedDb";

import PhoneCallbackOutlinedIcon from "@material-ui/icons/PhoneCallbackOutlined";
import MissedVideoCallOutlinedIcon from "@material-ui/icons/MissedVideoCallOutlined";
import GetShort from "../../helpers/GetShort";
import { cleanUpIndexedDB } from "../../helpers/IndexedDb";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { toast } from "react-toastify";

import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { object } from "yup";

const useStyles = makeStyles((theme) => ({
  loadMoreButton: {
    color: "#fff",
    cursor: "pointer",
    padding: "2px 0px",
    zIndex: "2",
    alignItems: "center",
    userSelect: "none",
    borderRadius: "7px",
    justifyContent: "center",
    backgroundColor: "#0b708c",
    width: "100px",
    margin: "10px auto",
    position: "relative",
    boxShadow:
      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2)",
    textTransform: "uppercase",
    textAlign: "center",
  },

  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },

  messagesList: {
    backgroundColor: "#efeae2",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px",
    overflowY: "scroll",
    overflowX: "hidden",
    position: "relative", // adicionar posição relativa ao contêiner
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "90px",
    },
    ...theme.scrollbarStyles,
  },

  circleLoading: {
    color: green[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    marginBottom: "2px",
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "#ffffff",
    color: "#303030",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  messageLeftReaction: {
    marginRight: 20,
    marginTop: 2,
    marginBottom: 15,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "#ffffff",
    color: "#303030",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  adContainerLeft: {
    maxWidth: "800px",
    margin: "-3px -80px 6px 0px",
    overflow: "hidden",
    backgroundColor: "#f0f0f0",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  adMsg: {
    padding: 10,
    maxWidth: 800,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  adSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  adContainerRight: {
    maxWidth: "800px",
    margin: "-3px -80px 6px 0px",
    overflowY: "hidden",
    backgroundColor: "#cfe9ba",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  adMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  adSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  adTitle: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  quotedContainerLeft: {
    marginBottom: "10px",
    overflow: "hidden",
    backgroundColor: "#f0f0f0",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "#dcf8c6",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  messageRightReaction: {
    marginLeft: 20,
    marginBottom: 15,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: "#dcf8c6",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  quotedContainerRight: {
    marginBottom: "10px",
    overflowY: "hidden",
    backgroundColor: "#cfe9ba",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    bottom: 0,
    color: "#667781",
    position: "relative",
    right: "-70px",
    float: "right",
    margin: "5px 0",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: "#53bdeb",
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  downloadMedia: {
    width: "100%",
    padding: "5px 10px",
    textTransform: "lowercase",
    fontSize: "13px",
    minWidth: "200px",
    marginBottom: "10px",
    display: "block",
    "& .MuiButton-label": {
      position: "relative",
      padding: "10px 40px 0 30px",
      display: "inline-block",
      textOverflow: "ellipsis",
      wordWrap: "initial",
      whiteSpace: "nowrap",
      overflow: "hidden",
      height: "40px",
      lineHeight: "18px",
      "& .MuiButton-startIcon": {
        position: "absolute",
        top: "7px",
        left: "10px",
      },
      "& .MuiButton-endIcon": {
        padding: "3px",
        border: "1px solid #9e9e9e",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        textAlign: "center",
        position: "absolute",
        right: "10px",
        top: "2px",
        color: "#9e9e9e",
      },
    },
    "&:hover": {
      backgroundColor: "#0b708c",
      color: "#ffffff",
      "& .MuiButton-endIcon": {
        color: "#ffffff!important",
        borderColor: "#ffffff!important",
      },
    },
  },
  buttonsMessage: {
    width: "100%",
    padding: "12px",
    textAlign: "center",
    cursor: "pointer",
    userSelect: "none",
    color: "rgb(43, 115, 169)",
    fontWeight: "800",
    marginBottom: "10px",
    border: "1px solid #e0e0e0",
  },
  contactsInChat: {
    position: "relative",
    width: "100%",
    padding: "10px",
    cursor: "pointer",
    background: "#eeeeee",
    borderRadius: "5px",
    "& .contactProfilePicture": {
      position: "relative",
      border: "3px solid #eeeeee",
    },
    "& label": {
      marginTop: "10px",
      fontWeight: "700",
      color: "#757575",
    },
  },
  contactsInChatPopover: {
    padding: "10px",
  },
  annotation: {
    background: "#FACB9F",
  },
  ticketHeader: {
    boxShadow:
      "0 4px 5px 0 rgba(0,0,0,0.14),0 1px 10px 0 rgba(0,0,0,0.12),0 2px 4px -1px rgba(0,0,0,0.3)",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    margin: "10px 0",
    padding: "0 10px",
    "& label": {
      fontSize: "0.85rem",
      display: "inline-block",
      lineHeight: "30px",
      height: "30px",
      textOverflow: "ellipsis",
      wordWrap: "initial",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    "& div": {
      fontSize: "0.85rem",
      display: "inline-flex",
      lineHeight: "30px",
      height: "30px",
      margin: "0",
      padding: "0",
      position: "absolute",
    },
    "& span": {
      fontSize: "0.85rem",
      backgroundColor: "rgb(224, 224, 224)",
      boxShadow:
        "0 4px 5px 0 rgba(0,0,0,0.14),0 1px 10px 0 rgba(0,0,0,0.12),0 2px 4px -1px rgba(0,0,0,0.3)",
      color: theme.palette.primary.main,
      marginTop: "-3px",
    },
    "& hr": {
      height: "100%",
      marginTop: "5px",
      marginRight: "5px",
      width: "1px",
      float: "right",
      background: "#ffffff",
      opacity: "1",
    },
  },
  ticketHeaderId: {
    width: "110px",
  },
  ticketHeaderQueue: {
    width: "150px",
  },
  ticketHeaderAssigned: {
    width: "250px",
  },
}));

const reducer = (state, action) => {
  if (action.type == "LOAD_MESSAGES") {
    const messages = action.payload;

    const updatedMessages = new Map(
      state.map((message) => [message.id, message]),
    );

    messages.forEach((message) => {
      updatedMessages.set(message.id, message);
    });

    return Array.from(updatedMessages.values()).sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    );
  }

  if (action.type == "ADD_MESSAGE") {
    const newMessage = action.payload;

    const messageIndex = state.findIndex((m) => {
      return (
        (newMessage.id !== "await_undefined" && m.id == newMessage.id) ||
        (newMessage.fromMe &&
          !newMessage.Ticket?.isGroup &&
          newMessage.awaitSendUuid != null &&
          m.awaitSendUuid == newMessage.awaitSendUuid) ||
        (m.messageUUID &&
          newMessage.awaitSendUuid != null &&
          m.messageUUID == newMessage.awaitSendUuid)
      );
    });

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage;
    } else {
      state.push(newMessage);
    }

    // filtrar e ordenar mensagens
    const filterByUuid = (array) => {
      const uuids = {};
      const result = array.filter((obj) => {
        if (uuids[obj.id]) {
          return false;
        } else {
          uuids[obj.id] = true;
          return true;
        }
      });

      return result;
    };
    state = filterByUuid(state);
    state = state.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    return [...state];
  }

  if (action.type == "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload;

    const messageIndex = state.findIndex(
      (m) =>
        (messageToUpdate.id !== "await_undefined" &&
          m.id == messageToUpdate.id) ||
        (messageToUpdate.fromMe && m.timestamp == messageToUpdate.timestamp),
    );

    if (
      messageToUpdate?.annotation == true &&
      messageToUpdate?.isDeleted == true &&
      messageIndex !== -1
    ) {
      return state.filter((item) => item.id != messageToUpdate.id);
    }
    if (messageIndex !== -1) {
      state[messageIndex] = messageToUpdate;
      return [...state];
    } else {
      return state;
    }
  }

  if (action.type == "RESET") {
    return [];
  }
};

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const MessagesList = ({
  ticket,
  ticketId,
  isGroup,
  byTicketManagement,
  ctcId,
  searchOpen,
}) => {
  const classes = useStyles();

  const [messagesArray, dispatch] = useReducer(reducer, []);
  const [pageNumber, setPageNumber] = useState(1);
  const [notUpdatePage, setNotUpdatePage] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const lastMessageRef = useRef();
  const { user } = useContext(AuthContext);
  const [selectedMessage, setSelectedMessage] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  const currentTicketId = useRef(ticketId);

  // variaveis para renderizar contatos anexados
  const [contactAnchorEl, setContactAnchorEl] = useState(null);
  const contactOpen = Boolean(contactAnchorEl);
  const contactId = contactOpen ? "contact-simple-popover" : undefined;
  const [contacts, setContacts] = useState([]);
  const history = useHistory();

  // Criação da referência para a box externa
  const outerBoxRef = useRef(null);

  // Variaveis para renderização de emoji
  const [emojiMessageId, setEmojiMessageId] = useState(null);
  const [emojiAnchorEl, setEmojiAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });

  // variavel para controlar a primeira mensagem de cada ticket
  const ticketIds = [];
  const [queues, setQueues] = useState([]);
  const [users, setUsers] = useState([]);

  // variavel de controle para resgatar o id de tickets do histórico de mensagens
  const [controlledUpdate, setControlledUpdate] = useState(null);

  // variaveis de controle para pesquisar mensagem dentro da conversa
  const searchWithinTheConversationInitialState = {
    open: false,
    text: "",
    messages: [],
    currentPosition: 0,
  };
  const [searchWithinTheConversation, setSearchWithinTheConversation] =
    useState(searchWithinTheConversationInitialState);
  const [
    searchWithinTheConversationLoading,
    setSearchWithinTheConversationLoading,
  ] = useState(false);
  const [scrolledTo, setScrolledTo] = useState(null);

  const ticketInitialState = {
    open: false,
    connectionId: undefined,
    ticketId: undefined,
    userId: undefined,
  };
  const [ticketProps, setTicketProps] = useState(ticketInitialState);

  useEffect(() => {
    if (searchOpen) searchWithinTheConversationOpen();
  }, [searchOpen]);

  useEffect(() => {
    if (!scrolledTo) return;
    const m = messagesArray.find((ms) => ms.id == scrolledTo);
    if (m) scrollToBox(`#msg-${m.id}`, m.fromMe);
    setSearchWithinTheConversationLoading(false);
    setScrolledTo(null);
  }, [messagesArray, scrolledTo]);

  function handleFindIsReaction(currentPosition) {
    const checkElementExist = () => {
      let isReaction = document.querySelectorAll(".EmojiPickerReact");
      if (!isReaction || isReaction.length == 0) return;
      isReaction = isReaction[0]?.style?.height !== "450px";
      if (!isReaction || isReaction == null) {
        const { top, left } = currentPosition;
        // necessário para criar um reposicionamento do elemento
        setAnchorPosition({ top: top - 5, left: left - 5 });
        setTimeout(() => setAnchorPosition({ top: top, left: left }), 500);
      } else {
        setTimeout(checkElementExist, 500);
      }
    };
    checkElementExist();
  }

  const handleContactModalClose = () => {
    setTicketProps(ticketInitialState);
  };

  const handleEmojiClick = (event, fromMe, messageId) => {
    const rect = event.currentTarget.getBoundingClientRect();

    const positionVertical = rect.top + rect.height - 100;
    const positionHoritonzal = rect.left - 140;

    const propsPosition = {
      top: positionVertical <= 300 ? positionVertical + 100 : positionVertical,
      left: positionHoritonzal,
    };

    setEmojiMessageId(messageId);
    setAnchorPosition(propsPosition);
    setEmojiAnchorEl(event.currentTarget);

    setTimeout(() => handleFindIsReaction(propsPosition), 500);
  };

  const handleEmojiClose = () => {
    setEmojiAnchorEl(null);
  };

  const sendReaction = async (emoji, messageId) => {
    try {
      await api.post(`/messages/reaction/${messageId}`, {
        reaction: emoji || "",
      });
    } catch (err) {
      console.error(err);
    } finally {
      setEmojiMessageId(null);
    }
  };

  const onEmojiClick = async (event, emojiObject) => {
    handleEmojiClose();
    sendReaction(event?.emoji, emojiMessageId);
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
    searchWithinTheConversationClose();

    currentTicketId.current = ticketId;
  }, [ticketId, ctcId]);

  // Função para mover o scroll para uma box interna específica
  const scrollToBox = (selector, fromMe) => {
    // Acessa a box externa
    const outerBox = document.getElementById("messagesList");

    // Tentar localizar pelo ID, mesmo que comece com número
    const id = selector.replace("#", "");
    const innerBox = document.getElementById(id);

    if (innerBox && outerBox.contains(innerBox)) {
      // Move o scroll da box externa para a posição da box interna (-50px de ajuste)
      outerBox.scrollTop = innerBox.offsetTop - 50;

      // Pega a segunda div dentro do innerBox
      const secondChildDiv =
        fromMe == true
          ? innerBox.querySelectorAll("div")[1]
          : isGroup == true
            ? innerBox.querySelectorAll("div")[1]
            : innerBox.querySelectorAll("div")[0];

      if (secondChildDiv) {
        // Adiciona efeito de foco na segunda div filha
        secondChildDiv.style.transition = "background-color 0.6s ease";
        secondChildDiv.style.backgroundColor =
          fromMe == true ? "#B5CCA3" : "#bdbdbd";

        // Remove o destaque após 1 segundo
        setTimeout(() => {
          secondChildDiv.style.backgroundColor = "";
        }, 1000);
      }
    }
  };

  const updateLocalMessages = async (indexedDbKey, ms, log = false) => {
    const localValues = await getAllItems(user?.adminId);
    let pg = localValues.find((lv) => lv.key == indexedDbKey);
    if (pg) {
      let { messages, ticket } = pg.value;

      for (const msg of ms) {
        if (ticket?.id && ticket.id != msg.ticketId) continue;
        // verificar se mensagem existe, se não adiciona-la
        const messageIndex = messages.findIndex((m) => {
          return (
            (msg.id !== "await_undefined" && m.id == msg.id) ||
            (msg.fromMe &&
              msg.awaitSendUuid != null &&
              m.awaitSendUuid == msg.awaitSendUuid) ||
            (m.messageUUID &&
              msg.awaitSendUuid != null &&
              m.messageUUID == msg.awaitSendUuid)
          );
        });

        if (messageIndex !== -1) {
          messages[messageIndex] = msg;
        } else {
          messages.push(msg);
        }
      }

      await updateItem(user.adminId, pg.id, { ...pg.value, messages });
    }
  };

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();
    (async () => {
      try {
        const { data: qs } = await api.get("/all_queue", {
          params: { showChatbot: true },
          signal: abortController.signal,
        });

        const { data: usrs } = await api.get("/usersList", {
          signal: abortController.signal,
        });

        if (!isMounted) return;

        if (Array.isArray(qs)) setQueues(qs);
        if (Array.isArray(usrs)) setUsers(usrs);
      } catch (err) {
        if (!isMounted || err.name == "AbortError") return;
        console.error({ err });
        toastError(err);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if (!ticketId) return;

    if (notUpdatePage == true) {
      setNotUpdatePage(false);
      return;
    }

    let isMounted = true;
    const abortController = new AbortController();

    setLoading(true);
    (async () => {
      // armazenar id da ultima mensagem para voltar o scroll posteriormente
      const firstMessage = document.querySelector(
        '#messagesList [data-message="1"]',
      );

      try {
        if (typeof ticketId !== "string" && typeof ticketId !== "number")
          return; // Verificação de tipo

        // verificar se o ticketId é 0 para enviar o contactId e pesquisar mensagens
        const isNewTicket = Number(ticketId) == 0;
        let params = { pageNumber };
        if (isNewTicket) params.contactId = ticket?.Contact?.id || "";
        if (byTicketManagement == true) params.markAsRead = "0";

        // verificar se as mensagens existem localmente
        const pages = [];
        const indexedDbKey = `listMessages-ticketId${ticketId}-user${user.id}-pageNumber`;
        if (pageNumber == 1) {
          const localValues = await getAllItems(user?.adminId);
          if (localValues)
            localValues
              .map((lv) => {
                if (lv.key.includes(indexedDbKey)) pages.push(lv);
              })
              .sort();
        }
        let data;
        let getLatestMessages = true;

        if (pages.length > 0) {
          getLatestMessages = false;

          for (let x = pages.length - 1; x >= 0; x--) {
            const isLast = x == pages.length - 1;
            data = {
              count: isLast ? pages[x].value.count : data.count,
              hasMore: isLast ? pages[x].value.hasMore : data.hasMore,
              messages: data?.messages
                ? [...data.messages, ...pages[x].value.messages]
                : pages[x].value.messages,
              ticket: isLast ? pages[x].value.ticket : data.ticket,
            };
          }

          // setar ultima pagina
          if (pages.length > 1) {
            setNotUpdatePage(true);
            setPageNumber(pages.length);
          }

          if (currentTicketId.current == ticketId) {
            dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
            setHasMore(data.hasMore);
            setControlledUpdate(new Date().getTime());

            // verificar se há novas mensagens
            if (
              data?.messages &&
              data.messages.length > 0 &&
              ticketId != "00000"
            ) {
              scrollToBottom();

              const messagesFromTicket = data.messages
                .filter((msg) => msg.ticketId === ticketId)
                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
              if (
                messagesFromTicket &&
                Array.isArray(messagesFromTicket) &&
                messagesFromTicket.length > 0
              ) {
                const messageIds = messagesFromTicket.map((msg) => msg.id);
                const { data: lastMessages } = await api.post(
                  `/messages/getLastMessages/${ticketId}/${messagesFromTicket[messagesFromTicket.length - 1].id}`,
                  {
                    messageIds:
                      messageIds && messageIds.length > 0 ? messageIds : [],
                    oldMessageCreatedAt:
                      messagesFromTicket[0]?.createdAt || null,
                    markAsRead: byTicketManagement == true ? "0" : "1",
                  },
                );

                if (Array.isArray(lastMessages) && lastMessages.length > 0) {
                  for (const lm of lastMessages) {
                    dispatch({ type: "ADD_MESSAGE", payload: lm });
                  }
                  // atualizar banco local
                  await updateLocalMessages(`${indexedDbKey}-1`, lastMessages);
                  scrollToBottom();
                }

                // recarregar as mensagens do banco para certificar que está tudo atualizado (do mais recente para o mais antigo)
                (async () => {
                  const ms = data.messages
                    .filter((m) => m.ticketId == ticketId)
                    .sort(
                      (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                    );
                  const { data: updatedMessages } = await api.post(
                    `/messages/checkMessagesStatus`,
                    {
                      messagesId: ms.map((m) => m.id),
                      ticketId,
                    },
                  );

                  if (
                    updatedMessages &&
                    Array.isArray(updatedMessages) &&
                    updatedMessages.length > 0
                  ) {
                    // atualizar mensagens
                    for (const um of updatedMessages) {
                      dispatch({ type: "ADD_MESSAGE", payload: um });
                    }
                    // atualizar banco local
                    await updateLocalMessages(
                      `${indexedDbKey}-1`,
                      updatedMessages,
                    );
                  }
                })();
              } else {
                getLatestMessages = true;

                // Apagar index DB
                if (user?.id) {
                  for (let x = pages.length - 1; x >= 0; x--) {
                    await deleteItem(user.adminId, pages[x].id);
                  }
                }
              }
            }
          }
        }

        if (getLatestMessages == true) {
          const { data: messagesData } = await api.get(
            "/messages/" + ticketId,
            {
              params,
            },
          );

          data = messagesData;

          if (ticketId != "00000")
            await addItem(
              { key: `${indexedDbKey}-${pageNumber}`, value: data },
              user?.adminId,
            );

          if (currentTicketId.current == ticketId) {
            dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
            setHasMore(data.hasMore);
            setControlledUpdate(new Date().getTime());
          }
        }

        if (pageNumber == 1 && data.messages.length > 1) {
          scrollToBottom();
        }
      } catch (err) {
        if (!isMounted || err.name == "AbortError") return;
        console.error({ err });
        toastError({
          response: {
            data: {
              error:
                err?.response?.data?.message ||
                err?.message ||
                "INTERNAL_ERROR",
            },
          },
        });
      } finally {
        if (pageNumber > 1 && firstMessage) {
          scrollToBox(`#msg-${firstMessage.id}`, firstMessage.fromMe);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [pageNumber, ticketId, ctcId]);

  useEffect(() => {
    if (!ticketId || !ticket) return;

    const preMessageEventName = `preMessage-${user.adminId}`;
    const appMessageEventName = `appMessage-${user.adminId}`;

    const joinChatBox = () => {
      if (ticket?.id) socket.emit("joinChatBox", `${ticket.id}`);
    };
    if (socket.connected) joinChatBox();
    socket.on("connect", joinChatBox);

    const preMessageEventFunction = async (data) => {
      let urlTicket = GetUrlTicketPath();
      if (data.ticket.uuid != urlTicket) return;

      const indexedDbKey = `listMessages-ticketId${data.ticket}-user${user.id}-pageNumber-1`;

      // Dispara evento de mensagem ficticia
      var dateActual = new Date().toISOString();
      const message = {
        id: `await_${data?.messageUUID}`,
        ack: 1,
        body: data.body,
        fromMe: true,
        quotedMsg: data?.reqBody?.quotedMsg,
        timestamp: String(Date.now()),
        isDeleted: false,
        mediaName: null,
        mediaType: data?.mediaType ? data.mediaType : "extendedTextMessage",
        mediaUrl: data?.mediaUrl ? data.mediaUrl : null,
        participant: "",
        Ticket: data.ticket,
        createdAt: dateActual,
        updatedAt: dateActual,
        awaitSendUuid: data?.messageUUID,
        annotation: data?.annotation === true,
      };
      dispatch({ type: "ADD_MESSAGE", payload: message });

      if (ticketId != "00000")
        await updateLocalMessages(indexedDbKey, [message], true);

      scrollToBottom();
    };

    const appMessageEventFunction = async (data) => {
      if (data.action == "create") {
        let urlTicket = GetUrlTicketPath();
        if (
          data.message?.Ticket?.uuid == urlTicket &&
          data.message?.Ticket?.id == ticketId
        ) {
          if (!data?.message?.fromMe && byTicketManagement != true) {
            try {
              const activeTicketId =
                data?.message?.Ticket?.id || data?.ticket?.id;
              if (activeTicketId) {
                await api.post(`/tickets/resetUnreadMessages`, {
                  ticketId: activeTicketId,
                });
              }
            } catch (err) {
              console.error({ err });
              toastError(err);
            }
          }

          dispatch({ type: "ADD_MESSAGE", payload: data.message });
          if (data?.message?.fromMe == true) {
            scrollToBottom();
          }

          const indexedDbKey = `listMessages-ticketId${ticketId}-user${user.id}-pageNumber-1`;

          if (ticketId != "00000")
            await updateLocalMessages(indexedDbKey, [data.message]);
        }
      }

      if (data.action == "update") {
        let urlTicket = GetUrlTicketPath();

        const ticketTmp = data.message?.Ticket || data?.ticket || data?.Ticket;
        const currentTicket = ticketTmp?.uuid == urlTicket ? true : false;
        const oldTickets =
          Array.isArray(ticketIds) && ticketIds.includes(ticketTmp?.id)
            ? true
            : false;

        if (currentTicket || oldTickets == true) {
          dispatch({ type: "UPDATE_MESSAGE", payload: data.message });

          if (currentTicket == true) {
            const indexedDbKey = `listMessages-ticketId${ticketTmp.id}-user${user.id}-pageNumber-1`;

            if (ticketId != "00000")
              await updateLocalMessages(indexedDbKey, [data.message]);
          } else {
            await cleanUpIndexedDB(user?.adminId, true);
          }
        }
      }
    };

    socket.on(preMessageEventName, preMessageEventFunction);
    socket.on(appMessageEventName, appMessageEventFunction);

    return () => {
      socket.off("connect", joinChatBox);
      socket.off(preMessageEventName, preMessageEventFunction);
      socket.off(appMessageEventName, appMessageEventFunction);
    };
  }, [ticketId, ticket, controlledUpdate]);

  const loadMore = () => {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

  const scrollToBottom = () => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({});
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  const handleCloseMessageOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  async function sendMesseger(messageData) {
    try {
      await api.post(`/messages/${ticket.id}`, messageData);
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  }

  function truncateText(text, maxLength) {
    if (text?.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    } else {
      return text;
    }
  }

  const checkAdMessage = (message) => {
    if (message?.dataJson) {
      const messageFormat = JsonParse(message.dataJson);
      if (messageFormat == null) return;
      const { message: msg } = messageFormat;
      const extendedTextMessage = msg?.extendedTextMessage;
      const link = findUrlInAd(extendedTextMessage);

      if (link) {
        const handleDivClick = () => {
          window.open(link, "_blank");
        };

        const imageUrl = findImageInAd(extendedTextMessage);
        const title = findTitleInAd(extendedTextMessage);
        const description = findDescriptionInAd(extendedTextMessage);

        if (!imageUrl && !title && !description) return;

        return (
          <div
            onClick={handleDivClick}
            style={{ width: "100%", cursor: "pointer" }}
            className={
              message.fromMe
                ? classes.adContainerRight
                : classes.adContainerLeft
            }
          >
            {imageUrl && (
              <img
                src={imageUrl}
                alt="adMessage"
                style={{ marginLeft: "5px", width: "90px", height: "90px" }}
              />
            )}
            <div className={classes.adMsg}>
              {!message.quotedMsg?.fromMe && (
                <span className={classes.adTitle}>
                  {truncateText(title, 60)}
                </span>
              )}
              <p>{truncateText(description, 130)}</p>
            </div>
          </div>
        );
      }
    }
  };

  const checkMessageMedia = (message) => {
    if (
      message.mediaType == "locationMessage" ||
      message.mediaType == "liveLocationMessage"
    ) {
      const data = JsonParse(message.dataJson);
      const location =
        data?.message?.locationMessage || data?.message?.liveLocationMessage;
      return (
        <div>
          {location ? (
            <iframe
              width="500"
              height="200"
              style={{ borderColor: "#ff000000" }}
              src={`https://maps.google.com/maps?q=${location.degreesLatitude},${location.degreesLongitude}&t=&z=15&ie=UTF8&iwloc=&output=embed `}
            />
          ) : (
            "No Location Data..."
          )}
        </div>
      );
    }

    const isImageMedia = ["image", "imageMessage", "sticker"].includes(message.mediaType);
    if (isImageMedia) {
      let finalPath = process.env.REACT_APP_INTEGRATION_BAILEYS_URL;
      if (finalPath[finalPath.length - 1] != "/") finalPath += "/";

      const imageUrl = message?.driveUrl
        ? message.driveUrl
        : message?.mediaUrl && message.mediaUrl != ""
          ? `${finalPath}public/${message.mediaUrl.split("/").at(-1)}`
          : `${finalPath}public/${message.mediaName}`;

      return <ModalImageCors imageUrl={imageUrl} />;
    }

    if (message.mediaType == "audio" || message.mediaType == "audioMessage") {
      let finalPath = process.env.REACT_APP_INTEGRATION_BAILEYS_URL;
      if (finalPath[finalPath.length - 1] != "/") finalPath += "/";

      const audioSrc = message?.driveUrl
        ? message.driveUrl
        : `${finalPath}public/${message.mediaName}`;
      return (
        <audio key={audioSrc} controls style={{ maxWidth: "100%" }}>
          {/* <source src={audioSrc} type="audio/ogg"></source> */}
          <source src={audioSrc} type="audio/mp4" />
          <source src={audioSrc} type="audio/m4a" />
          <source src={audioSrc} type="audio/mpeg" />
          <source src={audioSrc} type="audio/ogg" />
          Seu navegador não suporta o elemento de áudio.
        </audio>
      );
    }

    if (message.mediaType == "videoCall") {
      return (
        <Typography component="p" style={{ padding: "10px" }}>
          <MissedVideoCallOutlinedIcon style={{ marginRight: "10px" }} />
          <MarkdownWrapper>{i18n.t("chat.videoCall")}</MarkdownWrapper>
        </Typography>
      );
    }
    if (message.mediaType == "voiceCall") {
      return (
        <Typography component="p" style={{ padding: "10px" }}>
          <PhoneCallbackOutlinedIcon style={{ marginRight: "10px" }} />
          {i18n.t("chat.voiceCall")}
        </Typography>
      );
    }

    if (message.mediaType == "videoMessage" || message.mediaType == "video") {
      let finalPath = process.env.REACT_APP_INTEGRATION_BAILEYS_URL;
      if (finalPath[finalPath.length - 1] != "/") finalPath += "/";

      // criar url final
      let finalUrl = "";
      if (message?.driveUrl) {
        finalUrl = message.driveUrl;
      } else if (message?.mediaUrl && message.mediaUrl != "") {
        finalUrl = `${finalPath}public/${message.mediaUrl.split("/").at(-1)}`;
      } else {
        finalUrl = `${finalPath}public/${message.mediaName.split("/").at(-1)}`;
      }

      return <video className={classes.messageMedia} src={finalUrl} controls />;
    } else if (
      (message?.driveUrl && String(message?.driveUrl).trim() != "") ||
      (message?.mediaUrl && String(message?.mediaUrl).trim() != "")
    ) {
      let finalPath = process.env.REACT_APP_INTEGRATION_BAILEYS_URL;
      if (finalPath[finalPath.length - 1] != "/") finalPath += "/";

      return (
        <>
          <div>
            <Tooltip
              arrow
              title={<Typography fontSize={20}>Download</Typography>}
            >
              <Button
                color="primary"
                variant="outlined"
                target="_blank"
                className={classes.downloadMedia}
                href={
                  message?.driveUrl
                    ? message.driveUrl
                    : `${finalPath}public/${message.mediaUrl.split("/").at(-1)}`
                }
              >
                <Box
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <InsertDriveFileIcon />
                  {message?.mediaName ? message.mediaName : "Download"}
                </Box>
                <Box
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <GetApp />
                </Box>
              </Button>
            </Tooltip>
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  const renderReactions = (message) => {
    return (
      <EmojiGroup
        reactions={JsonParse(message.reaction)}
        message={message}
        onRemove={() => sendReaction("", message.id)}
        max={4}
      />
    );
  };

  const renderMessageAck = (message) => {
    let ackIcon;
    let ackTooltip = [];
    let onlytext;

    const {
      ackHanded,
      ackRead,
      ackSent,
      editedAt,
      annotation,
      scheduling,
      isApi,
      isCampaing,
    } = message;

    const othersAck = annotation == true || isApi == true || message?.ack == 0;

    if (ackSent && !othersAck) {
      ackTooltip.push(
        <Typography key="ackSent" style={{ fontSize: "12px" }}>
          {i18n.t("ack.sent")} - {format(parseISO(ackSent), "dd/MM/yyyy HH:mm")}
        </Typography>,
      );
    }
    if (ackHanded && !othersAck) {
      ackTooltip.push(
        <Typography key="ackHanded" style={{ fontSize: "12px" }}>
          {i18n.t("ack.serverAck")} -{" "}
          {format(parseISO(ackHanded), "dd/MM/yyyy HH:mm")}
        </Typography>,
      );
    }
    if (ackRead && !othersAck) {
      ackTooltip.push(
        <Typography key="ackRead" style={{ fontSize: "12px" }}>
          {i18n.t("ack.read")} - {format(parseISO(ackRead), "dd/MM/yyyy HH:mm")}
        </Typography>,
      );
    }
    if (editedAt && !othersAck) {
      ackTooltip.push(
        <Typography key="ackRead" style={{ fontSize: "12px" }}>
          {"Editada"} - {format(parseISO(editedAt), "dd/MM/yyyy HH:mm")}
        </Typography>,
      );
    }

    if (message?.isApi == true) {
      ackIcon = <ApiIcon fontSize="small" className={classes.ackIcons} />;
      onlytext = i18n.t("ack.isApi");
    } else if (message?.annotation == true) {
      ackIcon = <EditIcon fontSize="small" className={classes.ackIcons} />;
      onlytext = i18n.t("ack.annotation");
    } else if (message?.scheduling == true) {
      ackIcon = (
        <AlarmOutlinedIcon fontSize="small" className={classes.ackIcons} />
      );
      onlytext = message?.sentBy?.name
        ? `${i18n.t("ack.schedulingBy")} ${message.sentBy.name}`
        : i18n.t("ack.scheduling");
    } else if (message?.isCampaing == true) {
      ackIcon = <NearMeIcon fontSize="small" className={classes.ackIcons} />;
      onlytext = i18n.t("ack.isCampaign");
    } else {
      switch (message.ack) {
        case 0:
          ackIcon = <ErrorIcon fontSize="small" className={classes.ackIcons} />;
          onlytext = i18n.t("ack.error");
          break;
        case 1:
        case 2:
          ackIcon = <Done fontSize="small" className={classes.ackIcons} />;
          onlytext = i18n.t("ack.sent");
          break;
        case 3:
          ackIcon = <DoneAll fontSize="small" className={classes.ackIcons} />;
          onlytext = i18n.t("ack.serverAck");
          break;
        case 4:
        case 5:
          ackIcon = (
            <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />
          );
          onlytext = i18n.t("ack.read");
          break;
        default:
          ackIcon = <ErrorIcon fontSize="small" className={classes.ackIcons} />;
          onlytext = i18n.t("ack.error");
      }
    }

    return (
      <HtmlTooltip
        arrow
        title={
          <React.Fragment>
            {ackTooltip.length == 0 ? onlytext : ackTooltip}
          </React.Fragment>
        }
      >
        {ackIcon}
      </HtmlTooltip>
    );
  };

  const renderMessageBrodcastAck = (message) => {
    if (message.remoteJid && message.remoteJid.includes("@broadcast")) {
      return (
        <Tooltip
          title={
            <Typography style={{ fontSize: "12px" }}>
              {i18n.t("ack.broadcast")}
            </Typography>
          }
        >
          <WifiTetheringSharpIcon
            fontSize="small"
            className={classes.ackIcons}
            style={{ paddingBottom: "2px" }}
          />
        </Tooltip>
      );
    }
  };

  const renderDailyTimestamps = (message, index) => {
    const isFirstMessage = index == 0;
    const isLastMessage = index == messagesArray.length - 1;
    const messageDay = parseISO(messagesArray[index].createdAt);
    const previousMessageDay =
      index > 0 ? parseISO(messagesArray[index - 1].createdAt) : null;
    const shouldRenderTimestamp =
      isFirstMessage || !isSameDay(messageDay, previousMessageDay);

    return (
      <>
        {shouldRenderTimestamp && (
          <span
            className={classes.dailyTimestamp}
            key={`timestamp-${message.id}`}
          >
            <div className={classes.dailyTimestampText}>
              {ConfigureDays(format(messageDay, "yyyy/MM/dd"))}
            </div>
          </span>
        )}
        {isLastMessage && (
          <div
            key={`ref-${message.createdAt}`}
            ref={lastMessageRef}
            style={{ float: "left", clear: "both" }}
          />
        )}
      </>
    );
  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesArray.length && index > 0) {
      let messageUser = messagesArray[index].fromMe;
      let previousMessageUser = messagesArray[index - 1].fromMe;

      if (messageUser !== previousMessageUser) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };

  const renderQuotedMessage = (message) => {
    return (
      <div
        className={clsx(classes.quotedContainerLeft, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
        style={{
          cursor: "pointer",
        }}
        onClick={() => navigateToMessage(message.quotedMsg)}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
          })}
        />
        <div className={classes.quotedMsg}>
          {!message.quotedMsg?.fromMe && (
            <span className={classes.messageContactName}>
              {message.quotedMsg?.Contact?.name}
            </span>
          )}
          {(message.quotedMsg?.mediaUrl ||
            message.quotedMsg?.driveUrl ||
            [
              "locationMessage",
              "liveLocationMessage",
              "voiceCall",
              "videoCall",
            ].includes(message.quotedMsg?.mediaType)) &&
            checkMessageMedia(message.quotedMsg)}
          {message.quotedMsg?.mediaType != "audio" && message.quotedMsg?.body}

          {message.quotedMsg?.dataJson &&
            renderMessageInteractiveOptions(message.quotedMsg)}
        </div>
      </div>
    );
  };

  const renderGroupContact = (isGroup, message) => {
    const participant = getGroupParticipantInfo(message);
    const messageContact = isGroupTicketContact(message?.Contact)
      ? null
      : message?.Contact;
    if ((isGroup && isGroup == true) || ticket?.Contact?.isGroup == true) {
      let contactName =
        participant?.name || messageContact?.name || message?.contactName || "";
      if (contactName == "") {
        try {
          const tmp = JSON.parse(message.dataJson);
          contactName =
            tmp?.pushName ||
            tmp?.Info?.PushName ||
            tmp?.info?.PushName ||
            tmp?.info?.pushName ||
            "";
        } catch {}
      }
      return <span className={classes.messageContactName}>{contactName}</span>;
    } else {
      return <></>;
    }
  };

  const isGroupTicketContact = (contact) => {
    if (!contact) return false;
    if (contact?.isGroup === true) return true;
    return (
      String(contact?.number || "") === String(ticket?.Contact?.number || "")
    );
  };

  const getGroupParticipantInfo = (message) => {
    const participants = Array.isArray(ticket?.GroupInformations?.participants)
      ? ticket.GroupInformations.participants
      : [];
    if (participants.length === 0) return null;

    const participantRaw =
      message?.participant || message?.Contact?.lid || message?.Contact?.number;
    if (!participantRaw) return null;

    const normalizedParticipant = String(participantRaw)
      .split("@")[0]
      .split(":")[0];
    return (
      participants.find((participant) => {
        const candidates = [
          participant?.number,
          participant?.id,
          participant?.jid,
          participant?.phoneNumber,
          participant?.PhoneNumber,
          participant?.lid,
          participant?.LID,
        ]
          .filter(Boolean)
          .map((value) => String(value).split("@")[0].split(":")[0]);
        return candidates.includes(normalizedParticipant);
      }) || null
    );
  };

  const renderGroupProfilePicture = (message) => {
    const participant = getGroupParticipantInfo(message);
    const messageContact = isGroupTicketContact(message?.Contact)
      ? null
      : message?.Contact;
    const participantProfilePicture =
      participant?.profilePictureUrl || messageContact?.profilePicUrl;
    const url =
      message?.fromMe == false
        ? participantProfilePicture
        : message?.Ticket?.whatsapp?.picConnection ||
          ticket?.whatsapp?.picConnection;
    return (
      <Avatar
        alt="Profile Picture"
        src={url}
        style={{
          marginRight: message?.fromMe == false ? 5 : 0,
          marginLeft: message?.fromMe == false ? 0 : 5,
        }}
      />
    );
  };

  const sendButtonReply = async (text) => {
    const clean = String(text || "").trim();
    if (!clean) return;
    await sendMesseger({
      read: 1,
      fromMe: true,
      mediaInBody: "",
      body: clean,
      cleanMsg: clean,
      quotedMsg: null,
      moduleId: String(ticket?.whatsapp?.moduleId || "1"),
    });
  };

  /** Normaliza botões de envio (WA Oficial) e recebimento (Baileys/Whatsmeow). */
  const extractInteractiveButtons = (rawData) => {
    const data = typeof rawData == "string" ? JsonParse(rawData) : rawData;
    if (!data) return [];

    const msg = data.message || data.Message || {};
    const normalized = [];

    const pushBtn = (btn) => {
      const text = String(btn?.text || "").trim();
      if (!text) return;
      normalized.push({
        text,
        type: String(btn?.type || "QUICK_REPLY").toUpperCase(),
        url: btn?.url,
        phone_number: btn?.phone_number,
        replyBody: String(btn?.replyBody || text).trim(),
      });
    };

    // WA Oficial (conexão envia template)
    let buttons = data?.template?.buttons || data?.buttons || [];
    if (
      (!Array.isArray(buttons) || buttons.length === 0) &&
      data?.template?.components
    ) {
      const comps = Array.isArray(data.template.components)
        ? data.template.components
        : [];
      const buttonsComp = comps.find(
        (c) => String(c?.type || "").toUpperCase() === "BUTTONS",
      );
      buttons = (buttonsComp?.buttons || []).map((b) => ({
        text: String(b?.text || "").trim(),
        type: String(b?.type || "").toUpperCase(),
        url: b?.url,
        phone_number: b?.phone_number,
        replyBody: String(b?.text || "").trim(),
      }));
    }
    if (Array.isArray(buttons) && buttons.length > 0) {
      buttons.forEach(pushBtn);
      if (normalized.length > 0) return normalized;
    }

    // buttonsMessage (recebido/enviado)
    const btnMsg = msg?.buttonsMessage || msg?.ButtonsMessage;
    if (Array.isArray(btnMsg?.buttons) && btnMsg.buttons.length > 0) {
      btnMsg.buttons.forEach((b) => {
        const display = b?.buttonText?.displayText || b?.ButtonText?.displayText;
        const bParsed = JsonParse(b?.buttonId || b?.ButtonID);
        const reply = bParsed?.button || bParsed || display;
        pushBtn({
          text: display,
          type: "QUICK_REPLY",
          replyBody: reply,
        });
      });
      if (normalized.length > 0) return normalized;
    }

    // templateMessage hidratado (recebido via Baileys/Whatsmeow)
    const hydrated =
      msg?.templateMessage?.hydratedTemplate ||
      msg?.templateMessage?.hydratedFourRowTemplate ||
      msg?.TemplateMessage?.hydratedTemplate ||
      msg?.TemplateMessage?.hydratedFourRowTemplate;
    const hydratedButtons = hydrated?.hydratedButtons || hydrated?.HydratedButtons;
    if (Array.isArray(hydratedButtons) && hydratedButtons.length > 0) {
      hydratedButtons.forEach((b) => {
        const qr = b?.quickReplyButton || b?.QuickReplyButton;
        const urlBtn = b?.urlButton || b?.UrlButton;
        const callBtn = b?.callButton || b?.CallButton;
        if (qr) {
          pushBtn({
            text: qr.displayText || qr.DisplayText,
            type: "QUICK_REPLY",
            replyBody: qr.displayText || qr.DisplayText || qr.id || qr.ID,
          });
        } else if (urlBtn) {
          pushBtn({
            text: urlBtn.displayText || urlBtn.DisplayText,
            type: "URL",
            url: urlBtn.url || urlBtn.URL,
          });
        } else if (callBtn) {
          pushBtn({
            text: callBtn.displayText || callBtn.DisplayText,
            type: "PHONE_NUMBER",
            phone_number: callBtn.phoneNumber || callBtn.PhoneNumber,
          });
        }
      });
      if (normalized.length > 0) return normalized;
    }

    // listMessage (menu/lista)
    const listMsg = msg?.listMessage || msg?.ListMessage;
    if (Array.isArray(listMsg?.sections) && listMsg.sections.length > 0) {
      listMsg.sections.forEach((section) => {
        (section?.rows || []).forEach((row) => {
          pushBtn({
            text: row?.title || row?.Title,
            type: "QUICK_REPLY",
            replyBody: row?.rowId || row?.RowId || row?.title || row?.Title,
          });
        });
      });
      if (normalized.length > 0) return normalized;
    }

    // interactiveMessage (formato atual do WhatsApp)
    const interactive = msg?.interactiveMessage || msg?.InteractiveMessage;
    const nativeButtons =
      interactive?.nativeFlowMessage?.buttons ||
      interactive?.NativeFlowMessage?.buttons ||
      [];
    if (Array.isArray(nativeButtons) && nativeButtons.length > 0) {
      nativeButtons.forEach((b) => {
        const name = String(b?.name || "").toLowerCase();
        let params = {};
        try {
          params = JsonParse(b?.buttonParamsJson || b?.ButtonParamsJSON || "{}") || {};
        } catch {
          params = {};
        }
        if (name === "cta_url") {
          pushBtn({
            text: params.display_text || params.displayText || params.title,
            type: "URL",
            url: params.url || params.cta_url || params.link,
          });
        } else if (name === "cta_call") {
          pushBtn({
            text: params.display_text || params.displayText || params.title,
            type: "PHONE_NUMBER",
            phone_number: params.phone_number || params.phoneNumber,
          });
        } else if (name === "single_select") {
          (params.sections || []).forEach((section) => {
            (section?.rows || []).forEach((row) => {
              pushBtn({
                text: row?.title || row?.header,
                type: "QUICK_REPLY",
                replyBody: row?.id || row?.rowId || row?.title,
              });
            });
          });
        } else {
          pushBtn({
            text:
              params.display_text ||
              params.displayText ||
              params.title ||
              params.id,
            type: "QUICK_REPLY",
            replyBody:
              params.display_text ||
              params.displayText ||
              params.title ||
              params.id,
          });
        }
      });
    }

    return normalized;
  };

  const renderMessageInteractiveOptions = (message) => {
    const buttons = extractInteractiveButtons(message?.dataJson);
    if (!Array.isArray(buttons) || buttons.length === 0) return null;

    return buttons.map((btn, index) => {
      const text = String(btn?.text || "").trim();
      if (!text) return null;
      const type = String(btn?.type || "QUICK_REPLY").toUpperCase();
      const key = `msg-btn-${message.id}-${index}-${text}`;

      if (type === "URL" && btn?.url) {
        return (
          <Box
            key={key}
            className={[classes.messageLeft, classes.buttonsMessage]}
            component="a"
            href={btn.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", display: "block" }}
          >
            {text}
          </Box>
        );
      }

      if (type === "PHONE_NUMBER" && btn?.phone_number) {
        return (
          <Box
            key={key}
            className={[classes.messageLeft, classes.buttonsMessage]}
            component="a"
            href={`tel:${String(btn.phone_number).replace(/\D/g, "")}`}
            style={{ textDecoration: "none", display: "block" }}
          >
            {text}
          </Box>
        );
      }

      return (
        <Tooltip
          key={key}
          arrow
          title={<Typography fontSize={20}>Selecionar botão</Typography>}
        >
          <Box
            className={[classes.messageLeft, classes.buttonsMessage]}
            onClick={async () => {
              await sendButtonReply(btn.replyBody || text);
            }}
          >
            {text}
          </Box>
        </Tooltip>
      );
    });
  };

  // funções para identificar contatos anexados
  const handleContactClick = (event, cts) => {
    setContactAnchorEl(event.currentTarget);
    setContacts(cts);
  };

  const handleContactClose = () => {
    setContactAnchorEl(null);
    setTimeout(() => {
      setContacts([]);
    }, 500);
  };

  const handleSaveContact = async (contact) => {
    let dt = {
      adminId: ticket.whatsapp?.adminId || null,
      connection: ticket.whatsapp?.numberConnection || null,
      queueId: null,
      name: contact.name,
      number: contact?.phoneNumber || contact?.number,
      forAll: 1,
      profilePicUrl: contact.profilePic,
      isStartTicket: 1,
      tagsId: JSON.stringify([]),
    };

    try {
      const { data } = await api.post("/contacts", dt);
      if (data) {
        if (data?.chooseQueues == true) {
          handleContactClose();
          setTicketProps({
            open: true,
            ticketId: data.id,
            connectionId: data.whatsappId,
          });
          return;
        } else if (data?.uuid) {
          handleContactClose();
          history.push(`/tickets/${data.uuid}`);
        }
      }
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  };

  const renderContactList = (ms) => {
    if (
      [
        "contactmessage",
        "contactsarraymessage",
        "contactarraymessage",
      ].includes(String(ms.mediaType).toLowerCase()) == false
    )
      return;
    if (!ms?.contacts) return;

    const cts = JsonParse(ms.contacts);
    if (!cts || !Array.isArray(cts) || cts.length == 0) return;
    let avatarImages = [];
    let contactNames =
      cts.length > 1
        ? `${cts[0].name} e ${cts.length - 1} outro(s)`
        : cts[0].name;
    for (let x = 0; x < 3; x++) {
      if (!cts[x]) break;
      avatarImages.push(
        <Avatar
          alt="contact profile picture"
          src={cts[x].profilePic || ""}
          className="contactProfilePicture"
          style={{
            position: x == 0 ? "relative" : "absolute",
            top: x == 0 ? 0 : "10px",
            left: x == 0 ? 0 : `${35 * x - 10 * (x - 1)}px`,
            zIndex: x == 0 ? 3 : x == 1 ? 2 : 1,
          }}
        />,
      );
    }

    return (
      <Box component="div">
        <Box
          aria-describedby={contactId}
          onClick={(event) => handleContactClick(event, cts)}
          className={classes.contactsInChat}
        >
          {avatarImages}
          <Typography component="label">{contactNames}</Typography>
        </Box>
      </Box>
    );
  };

  const renderEmojiPicker = (message, index) => {
    return (
      <IconButton
        id={`emoji-${message.id}`}
        style={{
          [message.fromMe ? "left" : "right"]: "-40px",
          bottom: "0px",
          position: "absolute",
          display: "none",
        }}
        aria-label="emoji"
        onClick={(e) => handleEmojiClick(e, message.fromMe, message.id)}
      >
        <EmojiEmotions />
      </IconButton>
    );
  };

  const handleMouseEnter = (messageId) => {
    const element = document.getElementById(`emoji-${messageId}`);
    if (element) {
      element.style.display = "block";
    }
  };

  const handleMouseLeave = (messageId) => {
    const element = document.getElementById(`emoji-${messageId}`);
    if (element) {
      element.style.display = "none";
    }
  };

  const getQueueName = (queueId) => {
    if (!queueId) return "Sem Fila";
    const queue = queues.find((qs) => qs.id == queueId);
    return queue ? queue.name : "Sem Fila";
  };

  const getUserName = (userId) => {
    if (!userId) return " - ";
    const user = users.find((usr) => usr.id == userId);
    return user ? user.name : " - ";
  };

  const getUniqueTicketUsers = (message) => {
    const ticketUsers = messagesArray
      .filter(
        (mArray) =>
          mArray.ticketId == message.ticketId && mArray.fromMe && mArray.userId,
      )
      .map((mArray) => mArray.userId);

    if (message?.Ticket?.userId) ticketUsers.push(message.Ticket.userId);
    if (message?.Ticket?.finishedBy)
      ticketUsers.push(message.Ticket.finishedBy);

    return [...new Set(ticketUsers)];
  };

  const renderParticipantAvatars = (uniqueTicketUsers) => {
    return uniqueTicketUsers.map((userId, index) => {
      const userName = getUserName(userId);
      return (
        <Tooltip
          key={userId}
          arrow
          title={<Typography fontSize={20}>{userName}</Typography>}
        >
          <Avatar
            component="span"
            style={{
              marginLeft: index > 0 ? "-20px" : "5px",
              zIndex: uniqueTicketUsers.length - index,
              width: "30px",
              height: "30px",
              top: "5px",
            }}
          >
            {GetShort(userName)}
          </Avatar>
        </Tooltip>
      );
    });
  };

  const renderTicketHeader = (message) => {
    const queue = getQueueName(message?.Ticket?.queueId);
    const assignedUser = getUserName(message?.Ticket?.userId);
    const uniqueTicketUsers = getUniqueTicketUsers(message);

    return (
      <Box className={classes.ticketHeader}>
        <Typography component="label" className={classes.ticketHeaderId}>
          Ticket #{message.ticketId}
          <Divider orientation="vertical" flexItem />
        </Typography>
        <Tooltip arrow title={<Typography fontSize={20}>{queue}</Typography>}>
          <Typography component="label" className={classes.ticketHeaderQueue}>
            Fila: {queue}
            <Divider orientation="vertical" flexItem />
          </Typography>
        </Tooltip>
        <Tooltip
          arrow
          title={<Typography fontSize={20}>{assignedUser}</Typography>}
        >
          <Typography
            component="label"
            className={classes.ticketHeaderAssigned}
          >
            {`Atribuído à: ${assignedUser}`}
            <Divider orientation="vertical" flexItem />
          </Typography>
        </Tooltip>
        <Box component="div">
          Participantes: {renderParticipantAvatars(uniqueTicketUsers)}
        </Box>
      </Box>
    );
  };

  const renderMessages = () => {
    if (messagesArray.length > 0) {
      const viewMessagesList = messagesArray.map((message, index) => {
        // verificar se é necessário criar o header do ticket
        let isFirst = false;
        if (
          message?.ticketId &&
          ticketIds.includes(message.ticketId) == false
        ) {
          ticketIds.push(message.ticketId);
          isFirst = true;
        }

        // verificar se é anotação apagada
        if (message?.annotation == true && message?.isDeleted == true) return;

        if (!message.fromMe) {
          return (
            <>
              {isFirst == true && renderTicketHeader(message)}
              {renderDailyTimestamps(message, index)}
              <Box
                onMouseEnter={() => handleMouseEnter(message.id)}
                onMouseLeave={() => handleMouseLeave(message.id)}
                style={{
                  display: "flex",
                  position: "relative",
                  marginBottom: "unset",
                }}
                key={message.id}
                id={`msg-${message.id}`}
                data-message="1"
              >
                {isGroup == true && renderGroupProfilePicture(message)}
                {renderMessageDivider(message, index)}
                <div
                  className={
                    message?.reaction
                      ? classes.messageLeftReaction
                      : classes.messageLeft
                  }
                  id={`component-msg-${message.id}`}
                >
                  {(ticket?.whatsapp?.moduleId == 1 ||
                    ticket?.whatsapp?.moduleId == 3 ||
                    ticket?.whatsapp?.moduleId == 4) &&
                    renderEmojiPicker(message, index)}
                  <div style={{ display: "flex", padding: "5px" }}>
                    <small style={{ marginRight: "20px" }}>
                      {format(parseISO(message.createdAt), "dd/MM/yyyy HH:mm")}
                      {message.isEdited ? " - Editada" : ""}
                    </small>
                  </div>
                  {(ticket?.whatsapp?.moduleId == 1 ||
                    ticket?.whatsapp?.moduleId == 3 ||
                    ticket?.whatsapp?.moduleId == 4) && (
                    <IconButton
                      variant="contained"
                      size="small"
                      id="messageActionsButton"
                      disabled={message.isDeleted == true}
                      className={classes.messageActionsButton}
                      onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                    >
                      <ExpandMore />
                    </IconButton>
                  )}
                  {renderGroupContact(isGroup, message)}
                  {checkAdMessage(message)}
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {(message.mediaName ||
                    message.driveUrl ||
                    [
                      "locationMessage",
                      "liveLocationMessage",
                      "voiceCall",
                      "videoCall",
                    ].includes(message.mediaType)) &&
                    checkMessageMedia(message)}
                  {renderContactList(message)}
                  <div
                    className={clsx(classes.textContentItem, {
                      [classes.textContentItemDeleted]:
                        message.isDeleted == true,
                    })}
                  >
                    {message.isDeleted == true && (
                      <Block
                        color="disabled"
                        fontSize="small"
                        className={classes.deletedIcon}
                      />
                    )}
                    <MarkdownWrapper>
                      {message.body != "" &&
                        [
                          "contactmessage",
                          "contactsarraymessage",
                          "voicecall",
                          "videocall",
                        ].includes(String(message.mediaType).toLowerCase()) ==
                          false &&
                        message.body}
                    </MarkdownWrapper>
                    <span className={classes.timestamp}>
                      {renderMessageBrodcastAck(message)}
                    </span>
                    {(() => {
                      let reactions = message?.reaction;

                      if (!Array.isArray(reactions)) {
                        try {
                          reactions = JSON.parse(reactions);
                        } catch {
                          reactions = [];
                        }
                      }

                      if (
                        Array.isArray(reactions) &&
                        reactions.length > 0 &&
                        message?.annotation !== true
                      ) {
                        return renderReactions({
                          ...message,
                          reaction: reactions,
                        });
                      }

                      return null;
                    })()}
                  </div>
                  {message.dataJson &&
                    renderMessageInteractiveOptions(message)}
                </div>
                <div style={{ flex: "1 1 0%" }} />
              </Box>
            </>
          );
        } else {
          return (
            <>
              {isFirst == true && renderTicketHeader(message)}
              {renderDailyTimestamps(message, index)}
              <Box
                onMouseEnter={() => handleMouseEnter(message.id)}
                onMouseLeave={() => handleMouseLeave(message.id)}
                style={{
                  display: "flex",
                  position: "relative",
                  marginBottom: "unset",
                }}
                key={message.id}
                id={`msg-${message.id}`}
                data-message="1"
              >
                {renderMessageDivider(message, index)}
                <div style={{ flex: "1 1 0%" }} />
                <div
                  className={classNames({
                    [classes.messageRightReaction]: message?.reaction
                      ? true
                      : false,
                    [classes.messageRight]: message?.reaction ? false : true,
                    [classes.annotation]:
                      message?.annotation == true ? true : false,
                  })}
                  id={`component-msg-${message.id}`}
                >
                  {(ticket?.whatsapp?.moduleId == 1 ||
                    ticket?.whatsapp?.moduleId == 3 ||
                    ticket?.whatsapp?.moduleId == 4) &&
                    message?.annotation != true &&
                    renderEmojiPicker(message, index)}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "5px",
                    }}
                  >
                    {message?.annotation == true && message?.sentBy?.name && (
                      <small
                        style={{
                          let: "10px",
                          marginRight: "20px",
                          fontWeight: "800",
                        }}
                      >
                        {message.sentBy.name}
                      </small>
                    )}
                    <small style={{ marginRight: "20px" }}>
                      {format(parseISO(message.createdAt), "dd/MM/yyyy HH:mm")}
                      {message.isEdited ? " - Editada" : ""}
                    </small>
                  </div>
                  {(ticket?.whatsapp?.moduleId == 1 ||
                    ticket?.whatsapp?.moduleId == 3 ||
                    ticket?.whatsapp?.moduleId == 4) && (
                    <IconButton
                      variant="contained"
                      size="small"
                      id="messageActionsButton"
                      disabled={message.isDeleted == true}
                      className={classes.messageActionsButton}
                      onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                    >
                      <ExpandMore />
                    </IconButton>
                  )}
                  {checkAdMessage(message)}
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {(message.mediaName ||
                    message.driveUrl ||
                    [
                      "locationMessage",
                      "liveLocationMessage",
                      "voiceCall",
                      "videoCall",
                    ].includes(message.mediaType)) &&
                    checkMessageMedia(message)}
                  {renderContactList(message)}
                  <div
                    className={clsx(classes.textContentItem, {
                      [classes.textContentItemDeleted]:
                        message.isDeleted == true,
                    })}
                  >
                    {message.isDeleted == true && (
                      <Block
                        color="disabled"
                        fontSize="small"
                        className={classes.deletedIcon}
                      />
                    )}
                    <MarkdownWrapper>
                      {message.body != "" &&
                        [
                          "contactmessage",
                          "contactsarraymessage",
                          "voicecall",
                          "videocall",
                        ].includes(String(message.mediaType).toLowerCase()) ==
                          false &&
                        message.body}
                    </MarkdownWrapper>
                    <span className={classes.timestamp}>
                      {renderMessageAck(message)}
                    </span>
                    {(() => {
                      let reactions = message?.reaction;

                      if (!Array.isArray(reactions)) {
                        try {
                          reactions = JSON.parse(reactions);
                        } catch {
                          reactions = [];
                        }
                      }

                      if (
                        Array.isArray(reactions) &&
                        reactions.length > 0 &&
                        message?.annotation !== true
                      ) {
                        return renderReactions({
                          ...message,
                          reaction: reactions,
                        });
                      }

                      return null;
                    })()}
                  </div>
                  {message.dataJson &&
                    renderMessageInteractiveOptions(message)}
                </div>
                {isGroup == true && renderGroupProfilePicture(message)}
              </Box>
            </>
          );
        }
      });
      return viewMessagesList;
    }
  };

  // funções para manipular o modal de pesquisa dentro da conversa
  const searchWithinTheConversationOpen = () => {
    setSearchWithinTheConversation({
      ...searchWithinTheConversationInitialState,
      open: true,
    });
  };

  const searchWithinTheConversationClose = () => {
    setSearchWithinTheConversation(searchWithinTheConversationInitialState);
  };

  const handleSearchWithinTheConversationChange = (e) => {
    const str = String(e.target.value);
    setSearchWithinTheConversation((prev) => ({
      ...prev,
      text: str,
    }));
  };

  const navigateToMessage = async (msg) => {
    try {
      setSearchWithinTheConversationLoading(true);

      // resgatar todas as mensagens do indexDB
      const pages = [];
      if (!ticket?.id || !user?.id)
        throw new Error(
          "Ticket e/ou usuário não encontrados para encontrar a mensagem.",
        );

      const indexedDbKey = `listMessages-ticketId${ticket.id}-user${user.id}-pageNumber`;
      const localValues = await getAllItems(user?.adminId);
      if (localValues)
        localValues
          .map((lv) => {
            if (lv.key.includes(indexedDbKey)) pages.push(lv);
          })
          .sort();

      let targetMessage = null;

      // verificar se a mensagem já existe no histórico atual
      for (const page of pages) {
        if (
          Array.isArray(page?.value?.messages) &&
          page.value.messages.length > 0
        ) {
          const idx = page.value.messages.findIndex((m) => m.id == msg.id);
          if (idx > -1) {
            targetMessage = page.value.messages[idx];
            break;
          }
        }
      }

      // se não existir trazer no histórico
      if (targetMessage == null) {
        let lastMessageOnTheFrontPage = null;

        const allMessages = pages.flatMap(
          (page) => page?.value?.messages ?? [],
        );

        if (allMessages.length > 0) {
          lastMessageOnTheFrontPage = allMessages.reduce((oldest, current) =>
            new Date(current.createdAt) < new Date(oldest.createdAt)
              ? current
              : oldest,
          );
        }

        const { data } = await api.post(
          `/messages/searchWithinTheConversation`,
          {
            messageId: msg.id,
            ticketId: ticket.id,
            lastMessageOnTheFrontPage: lastMessageOnTheFrontPage?.id || null,
          },
        );

        if (Array.isArray(data) && data.length > 0) {
          dispatch({ type: "LOAD_MESSAGES", payload: data });
          // setar para qual mensagem deve ser scrollado depois de processado
          setScrolledTo(msg.id);
          setControlledUpdate(new Date().getTime());
        }
      }

      // mover até a mensagem
      if (targetMessage != null) {
        scrollToBox(`#msg-${targetMessage.id}`, targetMessage.fromMe);
        setSearchWithinTheConversationLoading(false);
      }
    } catch (err) {
      toast.error(err);
      console.error({ err });
      setSearchWithinTheConversationLoading(false);
    }
  };

  const navigateCurrentPosition = async (opt) => {
    try {
      setSearchWithinTheConversationLoading(true);
      let cOption = searchWithinTheConversation.currentPosition;
      if (opt == "next") {
        cOption++;
        if (cOption > searchWithinTheConversation.messages.length) cOption = 1;
      } else {
        cOption--;
        if (cOption <= 0) cOption = searchWithinTheConversation.messages.length;
      }

      // identificar mensagem
      const msg = searchWithinTheConversation.messages[cOption - 1];
      if (!msg) throw new Error("Mensagem não encontrada.");

      await navigateToMessage(msg);

      setSearchWithinTheConversation((prev) => ({
        ...prev,
        currentPosition: cOption,
      }));
    } catch (err) {
      toast.error(err);
      console.error({ err });
      setSearchWithinTheConversationLoading(false);
    }
  };

  const handleSearchWithinTheConversationClear = (close) => {
    setSearchWithinTheConversation({
      ...searchWithinTheConversationInitialState,
      open: close == true ? false : true,
    });
  };

  const handleSearchWithinTheConversation = async () => {
    const str = String(searchWithinTheConversation.text);
    if (!str || str == "undefined" || str == "" || str.length <= 2) {
      handleSearchWithinTheConversationClear();
      return;
    }
    try {
      setSearchWithinTheConversationLoading(true);
      const { data } = await api.post(
        `/tickets/searchWithinTheConversation/${ticket.uuid}`,
        { message: str },
      );
      if (data)
        setSearchWithinTheConversation((prev) => ({
          ...prev,
          messages: data,
          currentPosition: 0,
        }));
    } catch (err) {
      console.error({ err });
      toastError(err);
    } finally {
      setSearchWithinTheConversationLoading(false);
    }
  };

  return (
    <div className={classes.messagesListWrapper}>
      <MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        handleClose={handleCloseMessageOptionsMenu}
        moduleId={ticket?.whatsapp?.moduleId}
      />
      <div id="messagesList" className={classes.messagesList} ref={outerBoxRef}>
        {hasMore && messagesArray.length > 0 && (
          <div
            className={classes.loadMoreButton}
            onClick={loadMore}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress color="inherit" size={16} />
            ) : (
              i18n.t("chat.loadMore")
            )}
          </div>
        )}
        {renderMessages()}
      </div>
      <Popover
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        open={Boolean(emojiAnchorEl)}
        anchorEl={emojiAnchorEl}
        onClose={handleEmojiClose}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
      >
        <EmojiPicker
          onReactionClick={(e) => onEmojiClick(e)}
          onEmojiClick={(e) => onEmojiClick(e)}
          reactionsDefaultOpen={true}
        />
      </Popover>
      <Popover
        id={contactId}
        open={contactOpen}
        anchorEl={contactAnchorEl}
        onClose={handleContactClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        classes={{ paper: classes.contactsInChatPopover }}
      >
        <Box component="div">
          <List component="nav" aria-label="secondary mailbox folders">
            {contacts.map((c) => {
              return (
                <ListItem button>
                  <ListItemAvatar>
                    <Avatar
                      alt="contact profile picture"
                      src={c.profilePic || ""}
                      className="contactProfilePicture"
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={c.name || ""}
                    secondary={c.number || ""}
                  />
                  <ListItemSecondaryAction>
                    <Tooltip
                      arrow
                      title={
                        <Typography fontSize={20}>
                          Iniciar atendimento
                        </Typography>
                      }
                    >
                      <IconButton
                        edge="end"
                        aria-label="message"
                        onClick={() => handleSaveContact(c)}
                      >
                        <MessageIcon />
                      </IconButton>
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Popover>
      <TicketsQueueSelect
        open={ticketProps?.open == true ? true : false}
        connectionId={ticketProps?.connectionId}
        ticketId={ticketProps?.ticketId}
        onClose={() => handleContactModalClose()}
      />
      <Box
        sx={{
          height: "50px",
          minWidth: "300px",
          background: "#eee",
          position: "fixed",
          display: searchWithinTheConversation.open == true ? "block" : "none",
          top: "132px",
          right: "12px",
          zIndex: "1200",
          boxShadow:
            "0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3)",
          padding: "10px",
        }}
      >
        <TextField
          id="searchWithinTheConversationInput"
          label={i18n.t("ticketOptionsMenu.searchWithinTheConversation")}
          variant="outlined"
          fullWidth
          size="small"
          disabled={searchWithinTheConversationLoading}
          value={searchWithinTheConversation.text}
          onChange={handleSearchWithinTheConversationChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearchWithinTheConversation();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Typography
                  style={{
                    fontSize: "0.85rem",
                    color: "#757575",
                    marginRight: "5px",
                  }}
                >
                  {`${searchWithinTheConversation?.currentPosition || 0} de ${searchWithinTheConversation?.messages?.length || 0}`}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => navigateCurrentPosition("next")}
                  disabled={
                    !searchWithinTheConversation?.messages ||
                    searchWithinTheConversation.messages.length == 0 ||
                    searchWithinTheConversationLoading
                  }
                >
                  <ExpandLessIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => navigateCurrentPosition("prev")}
                  disabled={
                    !searchWithinTheConversation?.messages ||
                    searchWithinTheConversation.messages.length == 0 ||
                    searchWithinTheConversationLoading
                  }
                >
                  <ExpandMoreIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={handleSearchWithinTheConversation}
                  disabled={searchWithinTheConversationLoading}
                >
                  <SearchIcon />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={() => handleSearchWithinTheConversationClear(true)}
                  disabled={searchWithinTheConversationLoading}
                >
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: {
              backgroundColor: "#eee",
              padding: "0 4px",
            },
          }}
        />
      </Box>
    </div>
  );
};
export default MessagesList;
